import { m as motion, useScroll, useSpring } from "framer-motion";

/** Thin progress bar fixed to the top — for editorial article pages. */
export function ReadingProgress({ tone = "mint" }: { tone?: "mint" | "peach" | "butter" }) {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.2 });
  const color =
    tone === "peach" ? "var(--peach)" : tone === "butter" ? "var(--butter)" : "var(--mint)";

  return (
    <motion.div
      aria-hidden
      className="fixed inset-x-0 top-0 z-40 h-[3px] origin-left"
      style={{ scaleX, backgroundColor: color }}
    />
  );
}
